import { t } from '@/plugins/i18n'
import { ref } from 'vue'
import {
  productSkuEdit
} from '@/apis/inShipping'
import { ElMessage } from 'element-plus'

export default (form: any) => {
  const getProductSkuList = (val: never[]) => {
    const list = (val || []).map((e: any) => ({ ...e, deliveryNums: e.useable }))
    form.replenishPlanItemList = form.replenishPlanItemList.concat(list)
  }

  const addProductVisible = ref(false)
  const openAddProductVisible = () => {
    addProductVisible.value = true
  }

  const STableRef = ref()

  const productSelection = ref([])
  const handleSelection = (val: any) => {
    productSelection.value = val
  }

  const delMoreRow = () => {
    productSelection.value.forEach((p: any) => {
      const idx = form.replenishPlanItemList.findIndex((e: any) => e.productSku === p.productSku)
      form.replenishPlanItemList.splice(idx, 1)
    })
    STableRef.value.clearSelection()
  }
  const delRow = (productSku: any) => {
    const idx = form.replenishPlanItemList.findIndex((e: any) => e.productSku === productSku)
    form.replenishPlanItemList.splice(idx, 1)
    STableRef.value.clearSelection()
  }

  return {
    STableRef,
    getProductSkuList,
    addProductVisible,
    openAddProductVisible,
    handleSelection,
    delMoreRow,
    delRow
  }
}
